<template>
    <div class="code_matrix">
        <h1>Matrix for Code <span class="seed">{{seed}}</span></h1>
        <div class="table_wrapper">
            <table class="matrix">
                <tr v-for="row in field.rows">
                    <td v-for="col in row" :class="[col, 'field']">
                    </td>
                </tr>
            </table>
        </div>
        <p>
            <span :class="[field.begins, 'begins']">{{field.begins.toLocaleUpperCase()}}</span> begins.
        </p>
    </div>
</template>

<script>
    export default {
        name: 'CodeMatrix',
        props: {
            seed: {
                type: String,
                required: true
            }
        },
        computed: {
            field: function() {
                let r = [
                    [['white'], ['white'], ['white'], ['white'], ['white']],
                    [['white'], ['white'], ['white'], ['white'], ['white']],
                    [['white'], ['white'], ['white'], ['white'], ['white']],
                    [['white'], ['white'], ['white'], ['white'], ['white']],
                    [['white'], ['white'], ['white'], ['white'], ['white']],
                ];
                const pnrg = new window.Math.seedrandom(this.seed);
                let begins = pnrg.int32() % 2 == 1 ? 'red' : 'blue';
                const count_red = begins == 'red' ? 9 : 8;
                const count_blue = begins == 'blue' ? 9 : 8;

                let iblack = this.getNewRandomCoord(r, pnrg);
                r[this.getY(iblack)][this.getX(iblack)] = 'black';

                for (var x = 0; x < count_red; x++) {
                    let i = this.getNewRandomCoord(r, pnrg);
                    r[this.getY(i)][this.getX(i)] = 'red';
                }
                for (var x = 0; x < count_blue; x++) {
                    let i = this.getNewRandomCoord(r, pnrg);
                    r[this.getY(i)][this.getX(i)] = 'blue';
                }

                return {rows: r, begins: begins};
            }
        },
        methods: {
            getX: function (n) {
                return n % 5;
            },
            getY: function (n) {
                let y = Math.floor(n / 5);
                return y;
            },
            getRandomInt: function (max, prng) {
                const num = Math.abs(prng.int32()) % max;
                return num % max;
            },
            getNewRandomCoord: function (cur, prng) {
                let i = this.getRandomInt(25, prng);
                let x = this.getX(i);
                let y = this.getY(i);
                for (let m = 0; m < 10000 && cur[y][x] != 'white'; m++) {
                    i = this.getRandomInt(25, prng);
                    x = this.getX(i);
                    y = this.getY(i);
                }
                return i;
            }
        }
    }
</script>

<style scoped lang="scss">
    h3 {
        margin: 40px 0 0;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    .field {
        &.blue {
            background-color: blue;
        }

        &.red {
            background-color: red;
        }

        &.black {
            background-color: black;
        }
    }

    .begins {
        &.blue {
            color: blue;
        }
        &.red {
            color: red;
        }
    }



    a {
        color: #42b983;
    }

    .seed {
        background-color: lightgray;
        font-family: monospace;
    }

    .table_wrapper {
        width: 323.5px;
        margin-left: auto;
        margin-right: auto;
    }
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
